module.exports = __webpack_public_path__ + "static/startup-illustration-07a90e95734d23d7c99c9155feee8907.png";